import { render, staticRenderFns } from "./RegisterLogin.vue?vue&type=template&id=74155044&"
import script from "./RegisterLogin.vue?vue&type=script&lang=js&"
export * from "./RegisterLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports